/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { BPayPaymentInstrument } from "./BPayPaymentInstrument";
import * as t from "io-ts";

// required attributes
const BPayR = t.interface({});

// optional attributes
const BPayO = t.partial({
  bankName: t.string,

  groupCode: t.string,

  instituteCode: t.string,

  nameObfuscated: t.string,

  numberEncrypted: t.string,

  numberObfuscated: t.string,

  paymentInstruments: t.readonlyArray(
    BPayPaymentInstrument,
    "array of BPayPaymentInstrument"
  ),

  serviceState: t.string,

  surnameObfuscated: t.string,

  token: t.string,

  uid: t.string,

  uidHash: t.string
});

export const BPay = t.intersection([BPayR, BPayO], "BPay");

export type BPay = t.TypeOf<typeof BPay>;
